var ewechatTools = {}

ewechatTools.getEWechatUserInfo = async function(that,code,params,afterCall){
    let userinfo = null;
  //  let url = window.location.href
    //alert('url:'+url)
    let apiurl = '/api/robot/daily/getuserinfo/'+code+'/'+params
   // alert("apiurl:"+apiurl)
   // userinfo = sessionStorage.getItem("userinfo")

    userinfo = window.localStorage.getItem("userinfo")
    //alert(userinfo)
    //console.log(userinfo.userid)

    if(userinfo==null||userinfo.userid==null){
       // alert('no')
        userinfo = {};


    that.$http.get(apiurl).then((response) => {
        console.log(response.data)
        //alert('123:'+response.data.userId)
       // alert(response.data.name)
        userinfo.userId = response.data.userId
        userinfo.name = response.data.name
        userinfo.gender = response.data.gender
        userinfo.qrCode = response.data.qrCode
        userinfo.avatar = response.data.avatar
        userinfo.url = response.data.jsapiSign.url
        userinfo.jsapi_ticket = response.data.jsapiSign.jsapi_ticket
        userinfo.nonceStr = response.data.jsapiSign.nonceStr
        userinfo.timestamp = response.data.jsapiSign.timestamp
        userinfo.signature = response.data.jsapiSign.signature
        userinfo.jsapi_ticket = response.data.jsapiSign.jsapi_ticket
        userinfo.appid = response.data.jsapiSign.appid
        that.userinfo = userinfo;

        //sessionStorage.setItem("userinfo",JSON.stringify(userinfo))
        window.localStorage.setItem("userinfo",JSON.stringify(userinfo))
        //alert('getItem:'+window.localStorage.getItem("userinfo"))
        afterCall(that,response.data.userId)
        //alert('has');
       // after(userinfo)
       // afterCall(that,userinfo.userid)
      //  return userinfo;
    }).catch(error => {
        alert(error)
    })
    }else{
        //alert('has')
        console.log(userinfo.userid)
        that.userinfo = JSON.parse(userinfo);
       // alert('#@##'+userinfo.userid)
        afterCall(that,userinfo.userid)
    }

}

ewechatTools.getEWechatSign = async function(that,params,afterCall){
    //  let url = window.location.href
    //alert('url:'+url)
    let apiurl = '/api/robot/daily/getusersign/'+params

    //alert('apiurl:'+apiurl)
        that.$http.get(apiurl).then((response) => {

            console.log(response.data)
            //alert('123:'+response.data.userId)
            // alert(response.data.name)

            that.userinfo.url = response.data.jsapiSign.url
            that.userinfo.jsapi_ticket = response.data.jsapiSign.jsapi_ticket
            that.userinfo.nonceStr = response.data.jsapiSign.nonceStr
            that.userinfo.timestamp = response.data.jsapiSign.timestamp
            that.userinfo.signature = response.data.jsapiSign.signature
            that.userinfo.appid = response.data.jsapiSign.appid

            afterCall(that,that.userinfo.userId)

        }).catch(error => {
            alert(error)
        })

}


ewechatTools.doLogin = function(that){

}
//ewechatTools

ewechatTools.install = function (Vue, options) {
    Vue.prototype.$ewechatTools = ewechatTools
    Vue.ewechatTools = ewechatTools
}

export default ewechatTools
